import React, { useEffect } from "react";
import { httpRequest } from "egov-ui-kit/utils/api";
import { connect } from "react-redux";

const DashboardCard = ({ receiptDetails, handleClick , filterApi , activeCard}) => {


// const formatIndianNumber = (num) => {
//   if (num === undefined || num === null || isNaN(num)) return "-";

//   num = Number(num);

//   // const units = [
//   //   { value: 1e17, suffix: "Shankh" }, // 1,00,00,00,00,00,00,00,000
//   //   { value: 1e15, suffix: "Padma" },  // 1,00,00,00,00,00,00,000
//   //   { value: 1e13, suffix: "Neel" },   // 1,00,00,00,00,00,000
//   //   { value: 1e11, suffix: "Kharab" }, // 1,00,00,00,00,000
//   //   { value: 1e9, suffix: "Arab" },    // 1,00,00,00,000
//   //   { value: 1e7, suffix: "Cr" },      // 1,00,00,000
//   //   // { value: 1e5, suffix: "L" },       // 1,00,000
//   // ];

//     const units = [
//     { value: 1e17, suffix: "Cr" }, // 1,00,00,00,00,00,00,00,000
//     { value: 1e15, suffix: "Cr" },  // 1,00,00,00,00,00,00,000
//     { value: 1e13, suffix: "Cr" },   // 1,00,00,00,00,00,000
//     { value: 1e11, suffix: "Cr" }, // 1,00,00,00,00,000
//     { value: 1e9, suffix: "Cr" },    // 1,00,00,00,000
//     { value: 1e7, suffix: "Cr" },      // 1,00,00,000
//     // { value: 1e5, suffix: "L" },       // 1,00,000
//   ];

//   for (const unit of units) {
//     if (num >= unit.value) {
//       return (
//         (num / unit.value).toLocaleString("en-IN", {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         }) +
//         " " +
//         unit.suffix
//       );
//     }
//   }

//   return num.toLocaleString("en-IN");
// };
const formatIndianNumber = (num) => {
  if (num === undefined || num === null || isNaN(num)) return "0";

  num = Number(num);

  // Sirf 1 crore ya usse zyada ho tabhi "Cr" mein convert karo
  if (num >= 1e7) {
    return (
      (num / 1e7).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " Crore"
    );
  }

  // Baaki sab (lakh, hazaar, etc.) normal Indian comma format mein
  return num.toLocaleString("en-IN");
};
const getValue = (obj, key) => {
  if (obj && obj[key] !== undefined && obj[key] !== null) return obj[key];
  return undefined;
};

const getValueFromEither = (receiptDetails, filterApi, key) => {
  if (receiptDetails && receiptDetails[key] !== undefined && receiptDetails[key] !== null) {
    return receiptDetails[key];
  }
  if (filterApi && filterApi[key] !== undefined && filterApi[key] !== null) {
    return filterApi[key];
  }
  return undefined;
};

const cardData = [
  {
    id: "totalReceipts",
    title: "Total Receipts Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "totalReceipts")),
    color: "blue",
    icon: "account_balance_wallet",
  },
    {
    id: "openingBalance",
    title: "Total Opening Balance Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "openingBalance")),
    color: "orange",
    icon: "pie_chart",
  },
  {
    id: "grantAmount",
    title: "Total Grant Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "grandAmount")),
    color: "red",
    icon: "account_balance_wallet",
  },
  {
    id: "totalExpenditure",
    title: "Total Expenditure Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "totalExpenditure")),
    color: "green",
    icon: "pie_chart",
  },

  {
    id: "noOfContractor",
    title: "Total Contractors",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "contractorNumber")),
    color: "red",
    icon: "account_balance_wallet",
  },
  {
    id: "noOfSupplier",
    title: "Total Suppliers",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "supplierNumber")),
    color: "red",
    icon: "account_balance_wallet",
  },
  {
    id: "workOrder",
    title: "Total Work Order Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "workOrder")),
    color: "orange",
    icon: "assignment",
  },
  {
    id: "purchaseOrder",
    title: "Total Purchase Order Value",
    count: formatIndianNumber(getValueFromEither(receiptDetails, filterApi, "purchaseOrder")),
    color: "blue",
    icon: "assignment",
  },
];

  return (
    <div className="row">
      {cardData.map((card) => (
        <div className="col-md-3" key={card.id}>
          <div
            className={`${activeCard === card.id ? 'active'  : ''} dashboard-card ${card.color}`}
            onClick={() => handleClick(card)}
          >
            <div className="card-header-section">
              <div className="icon-circle">
                <i className="material-icons">{card.icon}</i>
              </div>
              <div className="cart-text-wrapper">
                <h6>{card.title}</h6>
                <h2>{card.count}</h2>
              </div>
            </div>
            <div className="wave-line"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardCard;


// WEBPACK FOOTER //
// src/modules/employee/Home/DashboardCard.js